// assets
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CategoryIcon from '@mui/icons-material/Category';
import ListAltIcon from '@mui/icons-material/ListAlt';

const icoMenu = {
    NotificationsActiveIcon,
    CategoryIcon,
    ListAltIcon
};

const notificaciones = {
    id: 'notificaciones',
    title: '',
    type: 'group',
    children: [
        {
            id: 'notificacionesMainMenu',
            title: 'Notificaciones',
            type: 'collapse',
            icon: icoMenu.NotificationsActiveIcon,
            children: [
                {
                    id: 'tipo_notificacion',
                    title: 'Tipo notificación',
                    type: 'item',
                    icon: icoMenu.CategoryIcon,
                    url: '/user/list-tipo-notificacion'
                },
                {
                    id: 'lista_notificacion',
                    title: 'Lista notificaciones',
                    type: 'item',
                    icon: icoMenu.ListAltIcon,
                    url: '/user/list-notificacion'
                }
            ]
        }
    ]
};

export default notificaciones;
